import * as React from 'react'
import styled from '@emotion/styled'
import { space } from 'styled-system'

const classNames = (...args: any) => args.join(' ')
const getClassName = (el: any) => (el.props && el.props.className) || ''

/**
 * A wrapping parent component used to control the spacing on all child components.
 * @param param0
 */
const StyledChildren = ({
    className,
    children,
    ...props
}) => {
    const styledChildren = React.Children.toArray(children).map((child) => (
        React.cloneElement(child, {
            className: classNames(getClassName(child), className)
        })
    ))
    return <>{styledChildren}</>
}

const Spacer = styled.div(space)

const SpaceChildren = styled(StyledChildren)(space)

export {
    Spacer,
    SpaceChildren
}
